// requestAnimationFrame polyfill by Erik Möller.
// Fixes from Paul Irish, Tino Zijdel, Andrew Mao, Klemen Slavič, Darius Bacon
// MIT license
if (!Date.now) {
    Date.now = function () {
        return new Date().getTime();
    };
}

(function () {
    'use strict';

    var vendors = ['webkit', 'moz'];
    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
        var vp = vendors[i];
        window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
    }
    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) // iOS6 is buggy
    || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
        var lastTime = 0;
        window.requestAnimationFrame = function (callback) {
            var now = Date.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function () {
                callback(lastTime = nextTime);
            }, nextTime - now);
        };
        window.cancelAnimationFrame = clearTimeout;
    }
})();

/** iOS FIX to incorrect focus bug with keyboard not showing up and then the last touchup element gets clicked. **/
if (/iPad|iPhone|iPod/g.test(navigator.userAgent)) {
    (function ($) {
        return $.fn.focus = function () {
            return arguments[0];
        };
    })(jQuery);
}

//Edge 15 intersection observer difference fix
if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype && !('isIntersecting' in IntersectionObserverEntry.prototype)) {

    Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
            return this.intersectionRatio > 0;
        }
    });
}

(function ($, asaUtil, undefined) {
    "use strict";

    // Fast for most debouncers, etc. but for transitions try and match typicall css transition length

    asaUtil.speeds = {
        fast: 200,
        transition: 300
    };

    //a11y check for enter, click, etc. for button like elements
    asaUtil.a11yClick = function (event) {
        if (event.type === 'click' || event.type === 'touchstart') {
            return true;
        } else if (event.type === 'keypress') {
            var code = event.charCode || event.keyCode;

            if (code === 32) {
                event.preventDefault();
            }

            if (code === 32 || code === 13) {
                return true;
            }
        } else {
            return false;
        }
    };

    //Debouncer to be used for scrolling and resize bindings
    asaUtil.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function later() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    //Generate a dynamic ID with any name of choosing with a sequential increase in numbers
    //Does a check to see if a duplicate already exists and then adds a new math random to it
    asaUtil.generateID = function () {
        var globalIdCounter = 0;
        return function (baseStr) {
            baseStr = baseStr ? baseStr : "generatedID-";
            var newString = baseStr + globalIdCounter++;
            if ($("#" + newString).length > 0) {
                newString = newString + parseInt(Math.random() * 10000000000);
            }
            return newString;
        };
    }();

    //Get correct viewport size helper - don't use $(window).width();
    asaUtil.getViewportW = window.getViewportW || function () {
        var win = typeof window != 'undefined' && window,
            doc = typeof document != 'undefined' && document,
            docElem = doc && doc.documentElement;

        var a = docElem.clientWidth,
            b = win.innerWidth;
        return a < b ? b : a;
    };

    /** Data Expander Setup - use for faux dropdowns, accordions, tabs, etc. */
    asaUtil.setupExpanders = function () {
        $("[data-expander]:not([data-init])").each(function (key, val) {
            var $expander = $(this),
                relatedData = $expander.data("target"),
                expanderID = $expander.attr("id"),
                parentID = $expander.data("parent"),
                isOverlay = $expander.data("expander") === "overlay" || false,
                isTabs = $expander.data("expander") === "tab" && parentID || false,
                isHold = $expander.data("hold") || false,
                $htmlTag = $("html");

            if (isTabs) {
                var $parentWrap = $("#" + parentID),
                    $relatedTabs = $parentWrap.find("[data-expander=tab]");
            }

            // POPOVER/DROPDOWN functionality
            function expanderControl() {
                // Clear out expander Handler for easy exit of expander if it exists

                if (isOverlay) {
                    $htmlTag.removeClass("js-data-expanded");
                }

                if ($expander.hasClass("active")) {
                    //update a11y and classes, etc. if already opened
                    var shouldSlideUp = false;

                    if (!isTabs) {
                        shouldSlideUp = true;
                    } else {
                        //Check to see if any other of your tab siblings are also open... if so close
                        if ($relatedTabs.filter("[aria-expanded=true]").length > 1) {
                            shouldSlideUp = true;
                        }
                    }

                    if (shouldSlideUp) {
                        $htmlTag.off("click touchstart keyup", dataexpanderHandler);
                        $controls.slideUp();
                        $expander.removeClass("active").attr("aria-expanded", "false");
                    }
                } else {
                    // Set up attributes and classes for styling and a11y
                    $expander.addClass("active").attr("aria-expanded", "true");

                    $controls.slideDown(function () {

                        if (isOverlay) {
                            $htmlTag.addClass("js-data-expanded");
                        }

                        // Set up later timeout functionality to make sure we can clearout if other data expanders are pressed
                        var later = function later() {
                            if ($controls.find("input, select, textarea").length > 0) {
                                $controls.find("input, select, textarea").first().focus();
                            } else {
                                $controls.focus();
                            }
                        };

                        timeoutItem = setTimeout(later, asaUtil.speeds.transition);
                    });

                    // Set up expander Handler for easy exit of expander
                    if (isOverlay) {
                        $htmlTag.addClass("js-data-expanded");
                    }

                    if (!isHold) {
                        $htmlTag.on("click touchstart keyup", dataexpanderHandler);
                    }
                }
            }

            //namespaced function for use in html event checks from above
            function dataexpanderHandler(e) {
                var requiresTrigger = false;
                //Check if escape is keyup-ed 
                if (e.which === 27) {
                    requiresTrigger = true;
                    $expander.focus();
                } else {
                    //otherwise check if touch/click is outside of bounds
                    var $target = $(e.target);
                    if ($target.closest("#" + relatedData).length <= 0 && $target.closest("#" + expanderID).length <= 0) {
                        requiresTrigger = true;
                    }
                }

                if (requiresTrigger) {
                    expanderControl();
                    //Clear timeout to help prevent focus / other data expander press conflicts
                    clearTimeout(timeoutItem);
                    timeoutItem = null;
                }
            }

            // No point in doing anything if there isn't a proper related element set
            if (relatedData) {
                var $controls = $("#" + relatedData),
                    timeoutItem = null,
                    isExpanded = $expander.hasClass("active");

                // make sure there is an ID set for the expander for a11y needs
                if (!expanderID) {
                    $expander.attr("id", asaUtil.generateID("data-expander-"));
                    expanderID = $expander.attr("id");
                }

                //Indicate initialization
                $expander.attr("data-init", "");

                // finish up a11y setup for related element
                $controls.attr({ "aria-labelledby": expanderID });

                //Setup proper roles for a11y and then bind interaction functionality

                $expander.attr({ "role": "button", "aria-expanded": isExpanded }).on("click", function (e) {
                    if (asaUtil.a11yClick(e) === true) {
                        e.preventDefault();
                        //Call function that controls show/hide
                        expanderControl();
                    }
                });

                if (isExpanded && !isHold) {
                    $htmlTag.on("click touchstart keyup", dataexpanderHandler);
                }
            }
        });
    };

    asaUtil.lazyLoadSpy = function (query, toggleClass) {
        var lazyImages = [].slice.call(document.querySelectorAll(query));

        if ("IntersectionObserver" in window) {
            var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        if (lazyImage.srcset) {
                            lazyImage.srcset = lazyImage.dataset.srcset;
                        }
                        lazyImage.classList.remove(toggleClass);
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });

            lazyImages.forEach(function (lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            // Possibly fall back to a more compatible method here
            lazyImages.forEach(function (lazyImage) {
                lazyImage.src = lazyImage.dataset.src;
                if (lazyImage.srcset) {
                    lazyImage.srcset = lazyImage.dataset.srcset;
                }
                lazyImage.classList.remove(toggleClass);
            });
        }
    };

    /** Stop referrer Phishing hack */
    asaUtil.setupExternalLinkSecurity = function () {
        $("a[target='_blank']:not([rel*='noopener'])").attr("rel", "noopener noreferrer");
    };

    /** Check if click/touch vs. keyboard user **/
    asaUtil.setupUserTypeCheck = function () {

        var $body = $("body"),
            $html = $("html");

        if (!$html.hasClass("js-user-bind-init")) {
            $html.addClass("js-user-bind-init");
            $body.on("keyup", function () {
                if (!$html.hasClass("js-keyboard-user")) {
                    $html.removeClass("js-click-user").addClass("js-keyboard-user");
                }
            });

            $body.on("click", function () {
                if (!$html.hasClass("js-click-user")) {
                    $html.removeClass("js-keyboard-user").addClass("js-click-user");
                }
            });
        }
    };
})(jQuery, window.asaUtil = window.asaUtil || {});

$(document).ready(function () {
    asaUtil.setupUserTypeCheck();
    asaUtil.setupExpanders();
    asaUtil.lazyLoadSpy(".lazy", "lazy");
});